import { createReducer } from 'redux-act';
import { setCampaign, clearCampaign } from './campaignActions';

const initialState = {
  campaign: undefined,
};

export const reducer = createReducer(
  {
    [setCampaign]: (state, campaign) => ({
      ...state,
      campaign,
    }),
    [clearCampaign]: (state) => ({ ...state, ...initialState }),
  },
  initialState,
);
